// App config / constants.
//
// CRA bakes env vars into the bundle at build time; they must be prefixed
// REACT_APP_ to be exposed to the client.

// WhatsApp contact — the floating button opens a new chat with this number.
// Digits only, country code first, no '+' (wa.me format). +52 624 157 32 57.
export const WHATSAPP_NUMBER = '526241573257';

// Note on the insurance/quote forms: they are parked under an unlinked /wip/ path
// (see App.tsx) and surfaced only via the temporary red "WIP" nav link (Header.tsx).
// They ship in every build but aren't part of the public site yet.
